import { dFurusatoAPIConfig } from "../config";

export const aggregateProject = async (slug: string) => {
  const url = `/app/projects/${slug}/aggregate`;
  const res = await dFurusatoAPIConfig.post(url);
  return res;
};
